import { render } from "./index.vue?vue&type=template&id=71fe0aa6&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=71fe0aa6&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=71fe0aa6&lang=css"

import exportComponent from "/spug/spug_api/repos/119_10566_20260928180206/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71fe0aa6"],['__file',"src/components/dataset-tree/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71fe0aa6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71fe0aa6', __exports__)) {
    console.log('reload')
    api.reload('71fe0aa6', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=71fe0aa6&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('71fe0aa6', render)
  })

}


export default __exports__